//
//
//
//
//
//
//
//
//
//
//

import { mapGetters } from 'vuex'
export default {
  name: 'status',
  props: {
    icon: {
      type: String,
      default: null
    },
    title: {
      type: String,
      default: null
    },
    status: {
      type: String,
      default: null
    }
  },
  computed: {
    ...mapGetters({
      user: 'auth/user'
    })
  }
}
